import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        myAccountTitle: {
            textStyle: {base: 'head-medium', lg: 'head-xlarge'},
            fontWeight: 500,
            color: 'text.default',
            marginTop: {base: 0, md: remCalc(24)},
            marginBottom: {base: remCalc(16), md: remCalc(24)},
            width: '100%',
        },
        horizontalDivider: {
            color: 'border.light',
            display: 'block',
            marginBottom: {base: remCalc(24), lg: remCalc(40)},
        },
        loginContainer: {
            paddingTop: {base: remCalc(16), md: remCalc(24), lg: remCalc(40), xl: remCalc(80)},
            paddingBottom: {base: remCalc(70), md: remCalc(128)},
            paddingInline: {base: remCalc(16), md: remCalc(24)},
            display: {md: 'flex', xl: 'flex'},
            justifyContent: {md: 'center', xl: 'center'},
        },
        '#login_content_caption': {
            display: 'none',
        },
        loginFormContainer: {
            display: 'flex',
            flexDirection: {base: 'column', lg: 'row'},
            flexWrap: 'wrap',
            alignContent: 'flex-start',
            width: '100% !important',
            justifyContent: {xl: 'space-between'},
            m: 0,
            p: 0,
        },
        loginFormWrap: {
            flexDirection: {base: 'column', lg: 'row'},
        },
        '.dln-registration__subtitle': {
            // textStyle: {base: 'head-small', sm: 'head-xsmall', md: 'head-small'},
            // fontWeight: 500,
            // color: 'text.default',
            // marginBottom: {base: remCalc(8), sm: remCalc(16)},
            display: 'none',
        },
        '.dln-registration__paragraph': {
            textStyle: 'body-medium',
            color: 'text.default',
            marginBottom: {base: remCalc(16), sm: remCalc(24), md: remCalc(16), lg: remCalc(24)},
            textAlign: 'inherit !important',
        },
        '.dln-loginForm__paragraph': {
            textStyle: 'body-medium',
            color: 'text.default',
            marginBottom: {base: remCalc(16), sm: remCalc(24), md: remCalc(16), lg: remCalc(24)},
        },
        '.dln-forgPsw__text': {
            display: 'block',
            marginBottom: {base: remCalc(16), md: remCalc(24)},
        },
        '.dlg-gigya-link': {
            py: {base: remCalc(16), md: remCalc(24)},
            textStyle: 'body-medium',
            color: 'text.tertiary',
            textDecoration: 'underline',
            display: 'block',
            textAlign: 'center',
            fontWeight: '700',
        },
        '.separator-wrapper': {
            height: remCalc(1),
            marginY: remCalc(30),
        },
        '.gigya-input-text': {
            borderRadius: '4px',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.dark',
            w: '100%',
            padding: `${remCalc(14)} ${remCalc(8)} ${remCalc(8)}`,
            textStyle: 'body-small',
            _disabled: {
                bg: 'button.background.primary-disabled',
                color: 'button.text.primary-disabled',
                _hover: {
                    bg: 'button.background.primary-disabled !important',
                    color: 'button.text.primary-disabled',
                },
            },
        },
        '.gigya-input-password': {
            borderRadius: '4px',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.dark',
            w: '100% !important',
            padding: `${remCalc(14)} ${remCalc(8)} ${remCalc(8)}`,
            textStyle: 'body-small',
            background: 'none !important',
            transition: 'none',
            minWidth: '0px',
        },
        '.gigya-reset *, div.gigya-reset, .gigya-reset span, .gigya-reset a:hover, .gigya-reset a:visited, .gigya-reset a:link, .gigya-reset a:active':
            {
                textStyle: 'body-small',
            },
        '.gigya-screen input[disabled], .gigya-screen input:disabled': {
            bg: 'transparent',
        },
        '.gigya-screen .gigya-composite-control-password-peek input': {
            marginLeft: '0 !important',
        },
        '.gigya-screen .gigya-composite-control-password-peek .gigya-show-password-button': {
            position: 'absolute',
            top: 0,
            bottom: 0,
            right: 0,
            background: 'transparent',
            padding: 0,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: remCalc(16),
            borderRadius: remCalc(4.5),
            marginRight: '8px',
        },
        '.gigya-screen .gigya-composite-control-password-peek .gigya-show-password-button .gigya-password-icon':
            {
                filter: 'grayscale(1)',
            },
        '.gigya-screen .gigya-composite-control-password-peek input[type=text] + .gigya-show-password-button .gigya-password-icon':
            {
                content: 'url(https://cdns.eu1.gigya.com/js/assets/screen-sets/hide-password.svg)',
            },
        '.gigya-screen .gigya-composite-control-password-peek input[type=password] + .gigya-show-password-button .gigya-password-icon':
            {
                content: 'url(https://cdns.eu1.gigya.com/js/assets/screen-sets/show-password.svg)',
            },
        '.gigya-screen .gigya-composite-control-password-peek .gigya-error-msg.gigya-error-msg-active':
            {
                marginTop: '0 !important',
            },
        '.gigya-screen .gigya-terms-error, .gigya-screen input.gigya-error, .gigya-screen input[type="text"].gigya-error, .gigya-screen input[type="password"].gigya-error, .gigya-screen input[type="email"].gigya-error, .gigya-screen select.gigya-error':
            {
                padding: `${remCalc(14)} ${remCalc(8)} ${remCalc(8)}`,
            },
        '.focused-control, .gigya-screen .gigya-composite-control-password-peek .gigya-show-password-button:focus':
            {
                border: '0 !important',
                boxShadow: 'none',
            },
        '.dlg-gigya-input-text-wrapper': {
            lineHeight: '150%',
            display: 'inline-block',
            width: '100%',
            textAlign: 'left',
            transition: 'all .4s cubic-bezier(.25,.8,.25,1)',
            position: 'relative',
            marginBottom: remCalc(10),
        },
        '.gigya-composite-control-password': {
            position: 'relative',
        },
        '.gigya-composite-control-textbox': {
            position: 'relative',
        },
        '.gigya-label-text': {
            color: 'text.secondary',
            textStyle: 'body-small',
        },
        '.gigya-error-msg': {
            minHeight: remCalc(24),
            color: 'text.danger',
            textAlign: 'left',
        },
        '.gigya-forgotPassword': {
            textStyle: 'body-small',
            color: 'text.tertiary',
            float: {base: 'none', lg: 'right'},
            textAlign: {base: 'inherit', lg: 'right'},
            textDecoration: 'underline',
            zIndex: 1,
        },
        '.gigya-input-submit': {
            w: '100%',
            display: 'inline-block',
            maxW: '100%',
            outlineWidth: 0,
            textStyle: 'body-medium',
            fontWeight: 'bold',
            alignItems: 'center',
            padding: '0',
            maxHeight: remCalc(40),
            bg: 'button.background.primary-default',
            borderRadius: [
                'button.radius.primary-default.base',
                'button.radius.primary-default.sm',
                'button.radius.primary-default.md',
                'button.radius.primary-default.lg',
            ],
            '.gigya-style-modern div.gigya-screen-dialog-main': {
                backgroundColor: 'background.default',
                padding: remCalc(20),
                maxwidth: remCalc(540),
            },
            '.gigya-style-modern div.gigya-screen-dialog-top': {
                padding: 0,
                border: 0,
                lineHeight: 0,
                backgroundColor: 'background.default',
            },
            color: 'button.text.primary-default',
            _hover: {
                bg: 'button.background.primary-hover',
            },
            _focus: {
                border: remCalc(2),
                borderColor: 'button.border.primary-focused',
                borderStyle: 'solid',
                bg: 'button.background.primary-focused',
            },
            _disabled: {
                bg: 'button.background.primary-disabled',
                color: 'button.text.primary-disabled',
                _hover: {
                    bg: 'button.background.primary-disabled !important',
                    color: 'button.text.primary-disabled',
                },
            },
            _pressed: {
                bg: 'button.background.primary-pressed',
                color: 'button.text.primary-pressed',
            },
        },
        '.dlg-gigya-button-wrapper': {
            width: '100%',
            margin: '0',
        },
        '.dlg-gigya-button-wrapper input[type=submit]': {
            width: '100%',
            maxWidth: remCalc(332),
            margin: '0 auto',
        },
        '.dlg-gigya-button-wrapper input[type=button]': {
            width: '100%',
            bg: 'button.background.primary-default',
            color: 'button.text.primary-default',
        },
        '.dlg-gigya-button-wrapper input[type=button], .dlg-gigya-button-wrapper input[type=submit]':
            {
                display: 'inline-block',
                outline: 'none',
                textStyle: 'body-medium',
                textAlign: 'center',
                boxShadow: 'none',
                transition: 'all .3s linear',
                WebkitAppearance: 'none',
                MozAppearance: 'none',
                cursor: 'pointer',
                WebkitUserSelect: 'none',
                userSelect: 'none',
                height: '40px',
                padding: '0',
                textDecoration: 'none',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                borderRadius: [
                    'button.radius.primary-default.base',
                    'button.radius.primary-default.sm',
                    'button.radius.primary-default.md',
                    'button.radius.primary-default.lg',
                ],
                overflow: 'hidden',
                maxWidth: remCalc(332),
            },
        '.gigya-password-input-container': {
            position: 'relative',
            width: '100%',
        },
        'ownid-fingerprint-button-widget': {
            zIndex: '2',
            '--ownid-button-widget-color': '#000',
            '--ownid-button-widget-border-color': '#000',
            opacity: '1',
            '--ownid-button-height': '39px',
            '--ownid-qr-or-width': '23px',
            top: '0px',
            left: '0px',
        },
        '.gigya-input-password.ownid-skip-password': {
            backgroundImage:
                'url(\'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" fill="%23888888" viewBox="0 0 24 24"%3E%3Cpath d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 13c-3.15 0-5.87-1.93-7.06-4.5C6.13 10.93 8.85 9 12 9s5.87 1.93 7.06 4.5c-1.19 2.57-3.91 4.5-7.06 4.5zm0-6c-1.11 0-2 .89-2 2s.89 2 2 2 2-.89 2-2-.89-2-2-2z"%3E%3C/path%3E%3C/svg%3E\')',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '16px 16px',
            backgroundPosition: 'right center',
            paddingRight: remCalc(30),
        },
        loginStack: {
            width: {base: '100%', md: '100%', lg: '50%', xl: '32%'},
            paddingInline: remCalc(0),
            // paddingRight: {base: '0', lg: remCalc(12)},
            position: 'relative',
        },
        registrationStack: {
            display: 'flex',
            width: {base: '100%', lg: 'calc(50% - 16px)', xl: 'calc(42% - 16px)'},
            marginTop: {base: remCalc(40), lg: 0},
            gap: 0,
        },
        registrationBenefits: {
            display: 'flex',
            gap: 0,
        },
        registrationButtonLogin: {
            gap: '0',
            width: {base: '100%', md: '100%', lg: '50%'},
            paddingInline: remCalc(0),
            paddingLeft: {base: '0', lg: remCalc(12)},
            marginTop: {base: remCalc(16), md: '0'},
            paddingTop: {base: remCalc(16), md: '0'},
            borderTop: {base: 'small', sm: 'none', md: 'small'},
            borderStyle: {base: 'solid', sm: 'none', md: 'none'},
            borderColor: 'border.light',
        },
        registrationButtonStack: {
            w: {base: '100%', lg: '50%'},
            marginBottom: {base: remCalc(40)},
        },
        registrationButton: {
            maxWidth: remCalc(332),
        },
        '.gigya-composite-control': {
            position: 'relative',
        },
        '.dlg-gigya-input-text-wrapper input': {
            borderRadius: '4px',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.dark',
            color: 'text.default',
            textStyle: 'body-xsmall',
            outline: '0',
            width: '100%',
            lineHeight: '16px',
            backgroundColor: 'transparent',
            padding: '14px 8px 8px',
            boxSizing: 'border-box',
            appearance: 'none',
        },
        '.dlg-gigya-input-text-wrapper input.gigya-error': {
            padding: '14px 8px 8px',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'text.danger',
        },
        '.dlg-gigya-input-text-wrapper .gigya-label': {
            lineHeight: '150%',
            display: 'inline-block',
            color: 'text.secondary',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            transformOrigin: '0 0',
            transition:
                'top .4s cubic-bezier(.25,.8,.25,1), transform .4s cubic-bezier(.25,.8,.25,1), color .4s cubic-bezier(.25,.8,.25,1), width .4s cubic-bezier(.25,.8,.25,1)',
            padding: '0 4px',
            overflow: 'hidden',
            pointerEvents: 'none',
            position: 'absolute',
            top: 'calc(50% - 21px)',
            left: '8px',
            zIndex: '1',
            textStyle: 'body-xsmall',
        },
        '.dlg-gigya-input-text-wrapper .gigya-label.gigya-error': {
            color: 'text.danger !important',
        },
        '.dlg-gigya-input-text-wrapper.ownId-left .gigya-label:has(+ ownid-fingerprint-button-widget, + .gigya-password-input-container ownid-fingerprint-button-widget)':
            {
                left: remCalc(80),
            },
        '.dlg-gigya-input-text-wrapper.focus-visible + .gigya-label': {
            backgroundColor: 'background.default',
            transform: 'translateY(calc(50% - 29px)) scale(.75)',
        },
        '.dlg-gigya-input-text-wrapper.focus-visible .gigya-label:first-of-type': {
            backgroundColor: 'background.default',
            transform: 'translateY(calc(50% - 29px)) scale(.75)',
        },
        '.gigya-composite-control-textbox:focus-within .gigya-label, .gigya-composite-control-textbox .gigya-label:has(~ .gigya-valid, ~ .gigya-error, ~ input[type=date]), [data-screenset-element-id=gigya-complete-registration-screen] .gigya-composite-control-textbox .gigya-label:has(~ input[name="profile.email"])':
            {
                transform: 'translateY(calc(50% - 29px)) scale(0.75)',
                backgroundColor: 'background.default',
                color: 'border.dark',
                fontSize: 'inherit',
            },
        '.gigya-composite-control-textbox .gigya-label:has(~ .gigya-error), .gigya-composite-control-textbox .gigya-label:has(~ .gigya-error) *':
            {
                color: 'text.danger',
            },
        '.gigya-composite-control-password:focus-within .gigya-label, .gigya-composite-control-password .gigya-label:has(~ .gigya-valid, ~ .gigya-error, ~ .gigya-password-input-container .gigya-valid, ~ .gigya-password-input-container .gigya-error)':
            {
                transform: 'translateY(calc(50% - 29px)) scale(0.75)',
                backgroundColor: 'background.default',
                color: 'border.dark',
                fontSize: 'inherit',
            },
        '.gigya-composite-control-password .gigya-label:has(~ .gigya-error, ~ .gigya-password-input-container .gigya-error), .gigya-composite-control-password .gigya-label:has(~ .gigya-error, ~ .gigya-password-input-container .gigya-error) *':
            {
                color: 'text.danger',
            },
        '.gigya-show-checkmark.gigya-valid': {
            backgroundImage: 'none',
        },
        '.gigya-show-validity-border.gigya-valid:not(.gigya-empty)': {
            borderColor: 'border.dark',
        },
        newUser: {
            textStyle: {base: 'head-small', sm: 'head-xsmall', md: 'head-small'},
            color: 'text.default',
            fontWeight: '500',
            marginBottom: {base: remCalc(8), sm: remCalc(16)},
        },
        registerNow: {
            textStyle: 'body-medium',
            color: 'text.default',
            marginBottom: {base: remCalc(16)},
        },
        '.gigya-spacer': {
            height: remCalc(24),
        },
        '.hr--solid:': {
            width: '100%',
            height: ' 1px',
            backgroundColor: 'border.light',
            margin: '24px 0',
        },
        '.dln-registrationForm__paragraph': {
            textStyle: 'body-small',
            color: 'text.default',
        },
        '.dlg-hidden': {
            display: 'none',
        },
        '.dln-completeForm__paragraph': {
            textStyle: 'body-xxsmall',
            lineHeight: '125%',
            width: ' 100%',
            color: 'text.default',
            margin: '0 0 16px',
        },
        '.dln-completeForm__paragraph--secondary': {
            textStyle: 'body-small',
            color: 'text.secondary',
            lineHeight: '125%',
            marginBottom: {base: remCalc(24), lg: remCalc(24)},
            display: 'inline-block',
        },
        '.dln-completeForm__paragraph--secondary:not(h2, label)': {
            display: 'flex',
            gap: remCalc(8),
            alignItems: 'center',
        },
        '.gigya-composite-control-checkbox .gigya-checkbox-text': {
            textStyle: 'body-small',
            fontWeight: '400',
            color: 'text.secondary',
            transition: 'color .12s linear',
            display: 'block',
            paddingLeft: remCalc(40),
        },
        '.gigya-composite-control-label.main-text dln-completeForm__text': {
            display: 'block',
            mb: remCalc(16),
        },
        '.gigya-composite-control.gigya-composite-control-submit.dlg-gigya-button-wrapper': {
            width: {base: '100%', lg: '50%'},
            paddingBottom: remCalc(10),
        },
        '.gigya-composite-control.gigya-composite-control-link': {
            display: 'block',
            width: {base: '100%', lg: '50%'},
        },
        '#gigya-login-popup-screen-container .gigya-composite-control.gigya-composite-control-submit.dlg-gigya-button-wrapper, #gigya-login-popup-screen-container .gigya-composite-control.gigya-composite-control-link':
            {
                width: '100%',
            },
        '#gigya-login-popup-screen-container .dlg-gigya-button-wrapper input[type=button], #gigya-login-popup-screen-container .dlg-gigya-button-wrapper input[type=submit]':
            {
                maxWidth: '100%',
            },
        '.dln-registrationForm__paragraph.dln-registrationForm__paragraph--secondary': {
            textStyle: 'head-small',
            fontWeight: 500,
            margin: '24px 0',
            textAlign: 'left',
        },
        '.dln-completeForm__paragraph a': {
            textDecoration: 'underline',
        },
        '.gigya-input-checkbox+label.gigya-label:before': {
            position: 'absolute',
            content: '""',
            display: 'block',
            width: remCalc(24),
            height: remCalc(24),
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.dark',
            backgroundColor: 'background.default',
            borderRadius: remCalc(2),
            top: 0,
            left: 0,
            zIndex: 1,
            transform: 'none',
        },
        '.gigya-input-checkbox+label.gigya-label:after': {
            position: 'absolute',
            display: 'none',
            content: '""',
            width: remCalc(7),
            height: remCalc(15),
            top: remCalc(3),
            left: remCalc(9),
            zIndex: 2,
            transform: 'rotate(45deg)',
            border: `${remCalc(1)} solid`,
            borderColor: 'border.dark',
            borderTop: 0,
            borderLeft: 0,
        },
        '.gigya-input-checkbox:checked+label.gigya-label:after': {
            display: 'block',
        },
        '.gigya-input-checkbox+label.gigya-label': {
            position: 'relative',
        },
        '.gigya-input-checkbox': {
            display: 'none',
            position: 'relative',
            width: remCalc(24),
            height: remCalc(24),
            flexShrink: 0,
        },
        '[data-screenset-element-id=gigya-register-screen] form .gigya-layout-row:nth-of-type(2)': {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
        },
        '[data-screenset-element-id=gigya-register-screen] form .gigya-layout-row:nth-of-type(2) .gigya-composite-control, [data-screenset-element-id=gigya-register-screen] form .gigya-layout-row:nth-of-type(2) .gigya-container-enabled':
            {
                //marginBottom: remCalc(10),
                w: {base: '100%', lg: '47%'},
            },
        registrationTitle: {
            textStyle: 'body-large',
            color: 'text.default',
            margin: ' 0 0 8px',
            fontWeight: '500',
        },
        registrationSutitle: {
            textStyle: 'body-xsmall',
            color: 'text.default',
            margin: ' 0 0 20px',
        },
        registrationIcons: {
            boxSize: 'iconsSize.xlarge',
            color: 'text.default',
            w: remCalc(24),
            h: remCalc(24),
        },
        registrationListItem: {
            alignItems: 'center',
            display: 'flex',
            width: '100%',
            borderBottom: 'small',
            borderColor: 'border.table',
            paddingY: remCalc(16),
            gap: remCalc(16),
        },
        registrationList: {
            margin: '0 0 40px',
            //listStyle: 'none',
        },
        registrationListText: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            height: 'auto',
            textStyle: 'body-small',
            color: 'text.default',
        },
        '.gigya-login-spacer': {
            height: remCalc(1),
            margin: {base: '30px 0', sm: '20px 0'},
        },
        '.gigya-social-login-container': {
            margin: '0 auto !important',
            width: 'auto !important',
        },
        '.gigya-login-providers-container': {
            width: 'auto !important',
        },
        '.gigya-social-login-container .gigya-login-provider-row': {
            marginBottom: remCalc(16),
        },
        '.gigya-social-login-container .gigya-login-provider-row .gigya-login-provider:not(:last-child)':
            {
                marginRight: '16px !important',
            },
        '[data-screenset-element-id=gigya-register-screen] .dln-btn.dln-btn--stroked': {
            display: 'inline-block',
            maxW: remCalc(332),
            width: '100%',
            outlineWidth: 0,
            textStyle: 'body-medium',
            fontWeight: 'bold',
            alignItems: 'center',
            padding: `${remCalc(18)} ${remCalc(24)}`,
            maxHeight: remCalc(40),
            bg: 'button.background.secondary-default',
            color: 'button.text.secondary-default',
            border: remCalc(2),
            borderColor: 'button.border.secondary-default',
            borderStyle: 'solid',
            borderRadius: [
                'button.radius.primary-default.base',
                'button.radius.primary-default.sm',
                'button.radius.primary-default.md',
                'button.radius.primary-default.lg',
            ],
            _hover: {
                border: 'none',
                color: 'button.text.secondary-hover',
                bg: 'button.background.secondary-hover',
            },
            _focus: {
                borderColor: 'button.border.secondary-focused',
                color: 'button.text.secondary-focused',
                bg: 'button.background.secondary-focused',
            },
            _disabled: {
                bg: 'button.background.secondary-disabled',
                borderColor: 'button.border.secondary-disabled',
                _hover: {
                    bg: 'button.background.secondary-disabled',
                    color: 'button.text.secondary-disabled',
                    border: remCalc(2),
                    borderColor: 'button.border.secondary-disabled',
                    borderStyle: 'solid',
                },
            },
            _pressed: {
                bg: 'button.background.secondary-pressed',
                color: 'button.text.secondary-pressed',
                borderColor: 'button.border.secondary-pressed',
            },
        },
        '[data-screenset-element-id=gigya-login-popup-screen] .dln-loginForm__subtitle': {
            paddingTop: {base: remCalc(24), lg: remCalc(40)},
            marginTop: {base: remCalc(24), lg: remCalc(40)},
            borderTop: 'small',
            borderColor: 'border.light',
            borderStyle: 'solid',
            textStyle: 'head-small',
            color: 'text.default',
            fontWeight: '500',
            marginBottom: remCalc(16),
        },
        '[data-screenset-element-id=gigya-login-popup-screen] .dln-btn': {
            textAlign: 'center',
            display: 'inline-block',
            maxW: '100%',
            width: '100%',
            outlineWidth: 0,
            textStyle: 'body-medium',
            fontWeight: 'bold',
            alignItems: 'center',
            padding: 0,
            maxHeight: remCalc(40),
            height: remCalc(40),
            bg: 'button.background.primary-default',
            borderRadius: [
                'button.radius.primary-default.base',
                'button.radius.primary-default.sm',
                'button.radius.primary-default.md',
                'button.radius.primary-default.lg',
            ],
            color: 'button.text.primary-default',
            _hover: {
                bg: 'button.background.primary-hover',
            },
            _focusVisible: {
                border: remCalc(2),
                borderColor: 'button.border.primary-focused',
                borderStyle: 'solid',
                bg: 'button.background.primary-focused',
            },
            _disabled: {
                bg: 'button.background.primary-disabled',
                color: 'button.text.primary-disabled',
                _hover: {
                    bg: 'button.background.primary-disabled !important',
                    color: 'button.text.primary-disabled',
                },
            },
            _active: {
                bg: 'button.background.primary-default',
            },
            _pressed: {
                bg: 'button.background.primary-pressed',
                color: 'button.text.primary-pressed',
            },
        },
        registrationFormStack: {
            width: {base: '100%', lg: 'calc(50% - 16px)'},
            margin: {base: '24px 0 0', md: '0 auto 0 0'},
        },
        backToHomepage: {
            display: 'block',
            marginBottom: remCalc(20),
            textStyle: 'body-xsmall',
            color: 'button.text.text-default',
            textDecoration: 'underline',
        },
        strongBlack: {
            color: 'text.default',
            fontWeight: 'bold',
        },
        divider: {
            marginBottom: {base: remCalc(40), lg: remCalc(24)},
        },
        confContainer: {
            paddingInline: {base: remCalc(16), md: remCalc(24), xl: remCalc(260)},
            paddingY: {base: remCalc(16), md: remCalc(40), xl: remCalc(80)},
            alignItems: 'center',
            gap: {base: remCalc(16), md: remCalc(24)},
        },
        ovalCheck: {
            alignSelf: 'center',
            color: 'text.inverse',
            backgroundColor: 'text.success',
            borderColor: 'text.success',
            border: 'large',
            borderRadius: 'full',
            borderStyle: 'solid',
            boxSize: 'iconsSize.xlarge',
        },
        confTextContainer: {
            gap: remCalc(16),
            textAlign: 'center',
            width: '100%',
        },
        dividerRule: {
            marginY: remCalc(20),
            backgroundColor: 'border.light',
            height: remCalc(1),
            borderBottom: 'none',
        },
        confTitle: {
            textStyle: 'head-xlarge',
            color: 'text.default',
            fontWeight: '500',
        },
        confMessage: {
            textStyle: 'body-medium',
            color: 'text.default',
            fontWeight: '400',
        },
        confButtons: {
            flexDirection: {base: 'column', md: 'row'},
            gap: {base: remCalc(16), md: remCalc(24)},
            width: '100%',
            justifyContent: 'center',
        },
        confButton: {
            width: {base: '100%', md: remCalc(351), lg: remCalc(226), xl: remCalc(332)},
        },
        '[data-screenset-element-id=gigya-subscribe-with-email-screen] .dln-checkout__innerColTitle':
            {
                color: 'text.default',
                textStyle: 'head-small',
                fontWeight: '500',
                marginBottom: {base: remCalc(24), lg: remCalc(32)},
            },
        '[data-screenset-element-id=gigya-subscribe-with-email-screen] .dln-newUserForm__paragraph--main':
            {
                color: 'text.secondary',
                textStyle: 'body-small',
                marginBottom: {base: remCalc(24), lg: remCalc(32)},
            },
        '[data-screenset-element-id=gigya-subscribe-with-email-screen] .dln-completeForm__paragraph--secondary:not(h2, label), [data-screenset-element-id=gigya-subscribe-with-email-screen-prodReg] .gigya-composite-control-checkbox':
            {
                marginBottom: {base: remCalc(24), lg: remCalc(32)},
                gap: remCalc(16),
            },
        '[data-screenset-element-id=gigya-subscribe-with-email-screen] .h-mb-25.gigya-composite-control-label':
            {
                display: 'block',
                textAlign: 'start !important',
            },
        '.guest-thank-you [data-gigya-name="email"]': {
            pointerEvents: 'none',
        },
        '.guest-thank-you .gigya-layout-row:first-of-type': {
            display: 'none',
        },
        '.guest-thank-you .dln-registrationForm__paragraph': {
            display: 'none',
        },
        '.guest-thank-you .gigya-composite-control.gigya-composite-control-link': {
            display: 'none !important',
        },
        '.js-sms-component': {
            width: '100% !important',
        },
        '.js-sms-component label': {
            backgroundColor: 'background.default',
            transform: 'translateY(calc(50% - 29px)) scale(.75)',
        },
        '.dln-registrationForm__paragraph--secondary': {
            display: 'none',
        },
        '.gigya-composite-control-link:focus, .guest-email-update .gigya-input-submit:focus': {
            outline: 'none !important',
            boxShadow: 'none !important',
            border: 'none !important',
        },
        '.dln-resetPssw__paragraph, .gigya-composite-control.gigya-composite-control-social-login':
            {
                mb: {base: remCalc(16)},
            },
        '.guest-email-update [data-screenset-element-id=gigya-subscribe-with-email-screen] .dln-checkout__innerColTitle':
            {
                display: 'none !important',
            },
        '.guest-email-update [data-screenset-element-id=gigya-subscribe-with-email-screen] .dln-newUserForm__paragraph.dln-newUserForm__paragraph--main':
            {
                display: 'none !important',
            },
        '.guest-email-update .gigya-input-submit, #gigya-reset-password-success-screen .gigya-composite-control.gigya-composite-control-link.gigya-button-link.dlg-gigya-button-wrapper input, #gigya-complete-registration-screen .gigya-composite-control.gigya-composite-control-submit.dlg-gigya-button-wrapper input':
            {
                width: 'auto',
                padding: '0 3rem !important',
            },
        '.guest-email-update .gigya-subscribe-with-email-form': {
            pt: remCalc(24),
        },
        '#gigya-complete-registration-screen .gigya-profile-form': {
            pt: remCalc(32),
        },
        '#gigya-complete-registration-screen .gigya-composite-control.gigya-composite-control-submit.dlg-gigya-button-wrapper':
            {
                mt: remCalc(32),
            },
        '#gigya-login-screen h2.gigya-composite-control.gigya-composite-control-header.dln-registration__subtitle.dln-checkout__innerColTitle':
            {
                display: 'block',
                color: 'text.default',
                textStyle: 'head-small',
                fontWeight: '500',
                marginBottom: {base: remCalc(24), lg: remCalc(32)},
            },
    },
    variants: {
        productRegistration: {
            loginStack: {
                width: '100%',
                paddingRight: 0,
            },
            '[data-screenset-element-id=gigya-login-screen] .gigya-login-spacer, [data-screenset-element-id=gigya-loginHK-screen] .gigya-login-spacer':
                {
                    margin: {base: '0', sm: '0', lg: '20px 0'},
                },
        },
        preCheckout: {
            loginStack: {
                w: {xl: remCalc(450)},
                marginTop: {base: 0, lg: remCalc(70)},
            },
            '#gigya-login-screen h2.gigya-composite-control.gigya-composite-control-header.dln-registration__subtitle.dln-checkout__innerColTitle':
                {
                    fontSize: remCalc(26),
                    lineHeight: remCalc(26),
                },
            '[data-screenset-element-id=gigya-subscribe-with-email-screen] .dln-checkout__innerColTitle':
                {
                    fontSize: remCalc(26),
                    lineHeight: remCalc(26),
                },
            '[data-screenset-element-id=gigya-login-screen] .gigya-login-spacer, [data-screenset-element-id=gigya-loginHK-screen] .gigya-login-spacer':
                {
                    margin: remCalc(21),
                },
            '.dln-resetPssw__paragraph, .gigya-composite-control.gigya-composite-control-social-login':
                {
                    marginBottom: remCalc(32),
                },
        },
    },
}
